import Const from 'constants';

export default function (state = {items: {}}, action) {
    state = {...state};
  
    if (action.type === Const.SET_RANDOM_POINTS) {
        state.items[action.lineupNumber] = {...action.points};
    } else if (action.type === Const.UNSET_RANDOM_POINTS) {
        state.items = {};
    }

    return state;
}